const trimTrailingSlash = (value: string): string => value.replace(/\/$/, '');

export const getPasskeyUserApiBaseUrl = (): string | undefined => {
  const env = window._env_;
  const explicitBaseUrl = env?.PASSKEY_API_BASE_URL?.trim();

  if (explicitBaseUrl) {
    return trimTrailingSlash(explicitBaseUrl);
  }

  const platformApiUrl = env?.PLATFORM_API_URL?.trim();
  if (platformApiUrl) {
    return `${trimTrailingSlash(platformApiUrl)}/user`;
  }

  return undefined;
};

export const isPasskeyPlatformApiConfigured = (): boolean => Boolean(getPasskeyUserApiBaseUrl());

export interface PasskeyPlatformRequestContext {
  lang?: string;
}

export const buildPasskeyPlatformHeaders = (
  context: PasskeyPlatformRequestContext = {},
  options?: { appType?: number },
): HeadersInit => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    device: 'mobile',
  };

  if (options?.appType !== undefined) {
    headers.appType = String(options.appType);
  }

  const vendorId = window._env_?.VENDERID?.trim();
  if (vendorId) {
    headers.vendor = vendorId;
  }

  const lang = context.lang?.trim();
  if (lang) {
    headers['Accept-Language'] = lang;
  }

  return headers;
};
